module.exports = __webpack_public_path__ + "static/media/ailin_img.f35386f5.svg";